// Session Storage
export const ACCESS_TOKEN_KEY = "accessToken" as const;
export const ZAHTJEV_TOKEN_KEY = "zahtjevId" as const;
export const UPLOAD_ID_KEY = "uploadId" as const;
export const UPLOAD_HASH_KEY = "uploadHashKey" as const;
export const ANALYTIC_USER_ID = "analyticUserId" as const;

// Cookies
export const COOKIE_PREFERENCES_KEY = "cookie_preferences" as const;
